import React from 'react';
import { useTranslation } from '@shared/core';
import { useAddressConfirmationController } from './AddressConfirmation.controller';
import {
  StyledAddressSummary,
  StyledAddressCheckbox,
  StyledAddressSummaryTitle,
  StyledAddressSummaryContent,
  StyledAddressConfirmationContainer,
  styles,
} from './AddressConfirmation.styles';
import { ButtonV2, DialogV2, Spinner, TextV2, Flex, CancelButton, Divider } from '@withjoy/joykit';

export const AddressConfirmation = () => {
  const { t } = useTranslation('yourRegistry');
  const { confirmButton, backButton, suggestedAddressText, originalAddressText, addressConfirmationNote, addressConfirmationTitle } = t('addressDialog');

  const {
    handlePreviousStep,
    setSuggestedAddressSelected,
    setOriginalAddressSelected,
    isSuggestedAddressSelected,
    saveSelectedAddress,
    onClose,
    originalAddress,
    suggestedAddress,
    mutationLoading,
  } = useAddressConfirmationController();

  if (!suggestedAddress || !originalAddress) {
    return null;
  }
  return (
    <StyledAddressConfirmationContainer __css={styles.addressConfirmationContainerContent}>
      <DialogV2.Header>
        <TextV2 typographyVariant="hed2">{addressConfirmationTitle()}</TextV2>
        <DialogV2.CloseButton onClick={onClose} />
      </DialogV2.Header>
      <Divider />
      <DialogV2.Body overflow={'auto'}>
        <Flex flexDirection="column">
          <TextV2 typographyVariant="body1">{addressConfirmationNote()}</TextV2>
          <Flex
            flexDirection="column"
            width={['100%', 'fit-content', 'fit-content']}
          >
            <StyledAddressSummaryTitle __css={styles.addressSummaryTitle}>{originalAddressText()}</StyledAddressSummaryTitle>
            <StyledAddressSummary
              __css={styles.addressSummary(!isSuggestedAddressSelected)}
              onClick={setOriginalAddressSelected}
            >
              <StyledAddressCheckbox
                overrides={{ Control: { props: { borderRadius: '10px' } } }}
                __css={styles.addressCheckbox(!isSuggestedAddressSelected)}
                isChecked={!isSuggestedAddressSelected}
              ></StyledAddressCheckbox>
              <StyledAddressSummaryContent __css={styles.addressSummaryContent}>
                <TextV2 typographyVariant="body1">{originalAddress.name}</TextV2>
                <TextV2 typographyVariant="body1">{originalAddress.address1}</TextV2>
                {originalAddress.address2 && <TextV2 typographyVariant="body1">{originalAddress.address2}</TextV2>}
                <TextV2 typographyVariant="body1">{`${originalAddress.city} ${originalAddress.state}, ${originalAddress.postalCode}`}</TextV2>
              </StyledAddressSummaryContent>
            </StyledAddressSummary>
            <StyledAddressSummaryTitle __css={styles.addressSummaryTitle}>{suggestedAddressText()}</StyledAddressSummaryTitle>
            <StyledAddressSummary
              onClick={setSuggestedAddressSelected}
              __css={styles.addressSummary(isSuggestedAddressSelected)}
            >
              <StyledAddressCheckbox
                __css={styles.addressCheckbox(isSuggestedAddressSelected)}
                isChecked={isSuggestedAddressSelected}
              ></StyledAddressCheckbox>
              <StyledAddressSummaryContent __css={styles.addressSummaryContent}>
                <TextV2 typographyVariant="body1">{suggestedAddress.name}</TextV2>
                <TextV2 typographyVariant="body1">{suggestedAddress.address1 || ''}</TextV2>
                {suggestedAddress.address2 && <TextV2 typographyVariant="body1">{suggestedAddress.address2}</TextV2>}
                <TextV2 typographyVariant="body1">{`${suggestedAddress.city || ''} ${suggestedAddress.state || ''}, ${suggestedAddress.postalCode || ''}`}</TextV2>
              </StyledAddressSummaryContent>
            </StyledAddressSummary>
          </Flex>
        </Flex>
      </DialogV2.Body>
      <Divider />
      <DialogV2.Footer borderRadius={[null, '0 0 12px 12px', '0 0 12px 12px']}>
        <Flex
          flexDirection={['column-reverse', 'row']}
          width={['100%', 'unset', 'unset']}
        >
          <CancelButton
            disabled={mutationLoading}
            onClick={handlePreviousStep}
            width={['100%', '132px']}
          >
            {backButton()}
          </CancelButton>
          <ButtonV2
            intent="primary"
            onClick={saveSelectedAddress}
            disabled={mutationLoading}
            type="submit"
            width={['100%', '177px']}
          >
            {mutationLoading ? <Spinner /> : confirmButton()}
          </ButtonV2>
        </Flex>
      </DialogV2.Footer>
    </StyledAddressConfirmationContainer>
  );
};
